const REALM_RE = /^[a-z][a-z0-9-]{2,39}$/
const CLIENT_ID_RE = /^[a-z][a-z0-9-]{2,62}$/
const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const CLIENT_ID_RESERVADOS = new Set([
  'account', 'account-console', 'admin-cli', 'broker', 'realm-management',
  'security-admin-console', 'admin-permissions',
])

// `$` do JS aceita antes de um \n final? Não: sem a flag m, `$` casa só no fim da string.
export function validaRealm(v: string): string | null {
  if (v === 'master') return 'O realm master é reservado.'
  if (!REALM_RE.test(v)) return 'Use 3 a 40 caracteres: minúsculas, números e hífen, começando por letra.'
  return null
}

export function validaGuid(v: string): string | null {
  return GUID_RE.test(v) ? null : 'Informe o GUID do tenant Entra (ex.: 9bb28593-e4e0-4ef3-89c8-a479f6bd629e).'
}

// Espelha _ROLE_ARN de src/consoleai/sso_keycloak_config.py. A conta ainda passa pela
// allowlist do backend (SSO_SECRET_CONSUMER_ACCOUNTS), que a tela não conhece.
const ROLE_ARN_RE = /^arn:aws:iam::\d{12}:role\/[\w+=,.@/-]{1,512}$/

export function validaRoleArn(v: string): string | null {
  return ROLE_ARN_RE.test(v)
    ? null
    : 'Informe o ARN da role IAM (ex.: arn:aws:iam::407389198066:role/api-acl).'
}

// Espelha _DEFAULT_ROLE de src/consoleai/sso_keycloak_config.py. Vazio = sem papel padrão.
const PAPEL_RE = /^[a-z][a-z0-9_-]{1,39}$/

export function validaPapelPadrao(v: string): string | null {
  if (v === '') return null
  return PAPEL_RE.test(v)
    ? null
    : 'Use 2 a 40 caracteres: minúsculas, números, hífen e sublinhado, começando por letra.'
}

export function validaClientId(v: string): string | null {
  if (!CLIENT_ID_RE.test(v)) return 'Use 3 a 63 caracteres: minúsculas, números e hífen, começando por letra.'
  if (CLIENT_ID_RESERVADOS.has(v) || v.endsWith('-realm')) return 'Este client_id é reservado pelo Keycloak.'
  return null
}

// Espelha validate_redirects / validate_post_logout_redirects de
// src/consoleai/sso_keycloak_config.py. Os testes valem sobre a string CRUA, antes de
// `new URL`, porque a URL normaliza (fragmento vazio, ponto final, userinfo vazio).
function autoridade(v: string): string {
  const m = /^[a-z][a-z0-9+.-]*:\/\/([^/?#]*)/i.exec(v)
  return m ? m[1] : ''
}

export function validaRedirect(v: string): string | null {
  let u: URL
  try {
    u = new URL(v)
  } catch {
    return 'URL inválida.'
  }
  if (u.protocol !== 'https:') return 'Só https:// é aceito.'
  if (v.includes('*')) return 'Curinga (*) não é aceito.'
  if (autoridade(v).includes('@') || u.username || u.password) return 'A URL não pode ter usuário ou senha.'
  if (v.includes('#')) return 'A URL não pode ter fragmento (#).'
  const host = u.hostname.replace(/\.+$/, '').toLowerCase()
  if (!host) return 'URL sem host.'
  if (host === 'localhost' || host.endsWith('.localhost')) return 'localhost não é aceito.'
  if (host.startsWith('[') || host.includes(':') || ipv4Like(host)) return 'Use um host DNS, não um IP.'
  return null
}

// inet_aton aceita 127.1, 0x7f.0.0.1 e inteiro puro: todo rótulo numérico/hex conta como IP.
function ipv4Like(host: string): boolean {
  const parts = host.split('.')
  return parts.length <= 4 && parts.every(p => /^(0x[0-9a-f]+|\d+)$/i.test(p))
}

export function validaRedirects(uris: string[]): string | null {
  if (uris.length === 0) return 'Informe ao menos um redirect.'
  for (const u of uris) {
    const e = validaRedirect(u)
    if (e) return `${u}: ${e}`
  }
  return null
}

export function validaPostLogoutRedirects(uris: string[]): string | null {
  for (const u of uris) {
    if (u.includes('##')) return `${u}: a URL não pode conter ##.`
    const e = validaRedirect(u)
    if (e) return `${u}: ${e}`
  }
  return null
}
